module.exports = __webpack_public_path__ + "img/b3.95cb1bf1.png";